import React from "react";
import CsvUploader from "./CsvUploader";


const UploadFidModal = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <>
            <div className="modal fade show" style={{ display: "block" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content upload-fid-modal">

                        <div className="modal-header">
                            <h5 className="modal-title">FID Tagging Upload</h5>
                            <button type="button" className="close" onClick={onClose}>
                                &times;
                            </button>
                        </div>

                        <div className="modal-body">
                            <CsvUploader onSuccess={onClose} />
                        </div>

                    </div>
                </div>
            </div>

            <div className="modal-backdrop fade show" />
        </>
    );
};

export default UploadFidModal;
